/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ColorTextInput/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'



/** @type {import('Simple/types.js').View} */
export default function ColorTextInput({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content/Content/Settings/Content/Theme/Primary/ColorTextInput",
  onChange,
  isInvalid
  
}) {
let settingsThemeoverrideMainValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'themeOverride.main',
})
let settingsThemeoverrideMainIsValidData = fromData.useDataIsValid({ viewPath,
context: 'settings',
path: 'themeOverride.main',
validate: fromValidate.color,
})
let settingsThemeoverrideMainChangeData = fromData.useDataChange({ viewPath,
context: 'settings',
path: 'themeOverride.main',
})
  return (<React.Fragment
>
<TysiaInputField
  viewPath={`${viewPath}/TysiaInputField`}
 data="settings.themeOverride.main"
 value={settingsThemeoverrideMainValueData}
 onChange={settingsThemeoverrideMainChangeData}
 validate="/Data/validate.js color"
 invalid={!settingsThemeoverrideMainIsValidData}
/>
{children}
</React.Fragment>)
}